/** Check if the currentId is a legacy id
 *
 * @param currentId
 * @returns boolean
 */
const isLegacyId = (currentId: string) =>
  currentId.includes('urn:adsk') || /^[0-9]*$/.test(currentId);

export default isLegacyId;
